import { Employee } from '../models/iEmployee';

export const employees: Employee[] = [
  {
    name: 'Divya Joy Palevski',
    address: '53 Wheeler Street Unit A224, <br/>Cambridge, MA 02138'
  },
  // {
  //   name: 'Aichel Campos Suarez',
  //   address: '1547 Green District Blvd, <br/>Marlborough, MA 01752'
  // },
  // {
  //   name: 'Dahlia Kalvinek',
  //   address: '53 Dodge Rd, Sutton MA 01590'
  // },
  // {
  //   name: 'Katerina Valeria Diaz-Sepulveda',
  //   address: '11 W Broadway Unit 505 <br/>Boston, MA 02127'
  // },
  {
    name: 'Julia Michelle Grober',
    address: '77 Bonair St Apt 3R, <br/>Somerville MA 02145'
  },
  // {
  //   name: 'Mary Jean Cash',
  //   address: '8 Daisy Lane, <br/>Raynham, MA 02767'
  // },
  // {
  //   name: 'Maxwell Kon',
  //   address: '25 Hillcrest Road.</br>Burlington, MA 01803',
  // },
  // {
  //   name: 'Bonnie Diaz-Torres',
  //   address: '520 Farms Dr.</br>Burlington, MA 01803',
  // },
  // {
  //   name: 'Dr. Omar Reid',
  //   address: '279 Walnut Ave.</br>Roxbury MA 02119',
  // },
  // {
  //   name: 'Omar G Reid',
  //   address: '15 Drummond Street.</br>Boston, MA 02121',
  // },
  // {
  //   name: 'Kelly Reid',
  //   address: '51 Montfern Ave. #3</br>Brighton, MA 02135',
  // },
  // {
  //   name: 'Jessica M. Garrity',
  //   address: '25 Selfridge Road.</br>Reading, MA 01867',
  // },
  {
    name: 'Kathy A. Jacques-Twichell',
    address: '77 Portside Circle.</br>East Falmouth, MA 02536',
  },
  // {
  //   name: 'Leeba Babu',
  //   address: '71 Ameica Blvd.</br> Ashland, MA 01721',
  // },
  // {
  //   name: 'Elizabeth Ann Bertram',
  //   address: '3 Thacher Street Unit #2<br/> Boston, MA 02113',
  // },
  // {
  //   name: 'Margaret E. Iarossi',
  //   address: '66 Buick St,<br/> Watertown, MA 02472',
  // },
  // {
  //   name: 'Alana Luttinger',
  //   address: '45 Buick St,</br> Watertown, MA 02472',
  // },
  // {
  //   name: 'Tameka N. Drummond',
  //   address: '7059 Deer Lodge Circle # 105,</br> Jacksonville, FL 32256',
  // },
  // {
  //   name: 'Amy E Bond',
  //   address: '56 Lafayette St</br> Marblehead, MA, 01945',
  // },
  // {
  //   name: 'Marina Kazakova',
  //   address: '49 Maple Street,</br> Belmont, MA 02478',
  // },
  // {
  //   name: 'Debra Beeferman',
  //   address: '700 Greendale Ave. Unit 11313,<br/> Needham MA 02492',
  // },
  // {
  //   name: 'Jennifer C. George',
  //   address: '20 Wellington Road,</br> Plymouth, MA 02360',
  // },
  // {
  //   name: 'Sofia Stratford',
  //   address: '275 Western Ave,<br /> Cambridge, MA 02139',
  // },
  // {
  //   name: 'Lynda Dague',
  //   address: '16 Virginia Drive,<br /> Milford, MA 01757',
  // },
  // {
  //   name: 'Belinda Campbell',
  //   address: '65 Michele Drive,<br /> Weymouth, MA 02190',
  // },
  // {
  //   name: 'Danielle Gerhardt',
  //   address: '320 D Street Apt. 136,<br /> Boston, MA 02127',
  // },
  // {
  //   name: 'Jillian Lea Kuhn',
  //   address: '47 Roseland Park Road,<br /> Woodstock, CT 06281',
  // },
  // {
  //   name: 'Meaghan McCluskey',
  //   address: '375 Medford St Apt 1,<br /> Somerville, MA 02145',
  // },
  {
    name: 'Christine Riordan',
    address: '19 Swan Lane,<br /> Billerica, MA 01821',
  },
  {
    name: 'Cynthia L. Reppucci',
    address: '14 Hesseltine Ave,<br /> Melrose, MA 02176'
  },
  // {
  //   name: 'Rachel Harty',
  //   address: '13 Governor Doherty Rd,<br /> Billerica, MA 01821'
  // },
  // {
  //   name: 'Sarah Piro',
  //   address: '34 Preston Street,<br /> Dedham, MA 02026'
  // },
  // {
  //   name: 'Lauren Elizabeth Mangold',
  //   address: '1260 Massachusetts Ave, Apt. 10,<br /> Arlington, MA 02476'
  // },
  // {
  //   name: 'William H. Hulsey',
  //   address: '15 Marigold Ave,<br /> Wellesley, MA 02482'
  // },
  // {
  //   name: 'Nathalie El-Saieh',
  //   address: '36 Chestnut St.<br /> Randolph, MA 02368'
  // },
  {
    name: 'Meghan Rowe',
    address: '6 Mystic Lane,<br /> Mansfield, MA 02048'
  },
  // {
  //   name: 'Ilana Bareket',
  //   address: '173 Oak Street #104,<br /> Newton, MA 02464'
  // },
  // {
  //   name: 'Ilana Bareket',
  //   address: '225 Woodlands Drive, <br/> Tuxedo Park, NY 10987'
  // },
  // {
  //   name: 'Tonya D. Allegrazza',
  //   address: '229 East Street,<br/> Uxbridge, MA 01569',
  // },
  // {
  //   name: 'Roberta F. Sullivan',
  //   address: '11 Winslow Way,<br/> Mansfield, MA 02048',
  // },
  {
    name: 'Gracie Hood',
    address: '213 Beacon St, Apt. BR,<br/> Boston, MA 02116',
  },
  {
    name: 'Kayley Foster',
    address: '232 Cambridge Street, Apt 3,<br/> Boston, MA 02114',
  },
  {
    name: 'Teresa Stock',
    address: '49 Hillcrest Rd,<br/> Needham, MA 02492',
  },
  {
    name: 'Emma Faustina Sullivan',
    address: '114 Brook St Apt #2,<br/> Brookline, MA 02445',
  },
  {
    name: 'Nicholas Wilder',
    address: '13 6th St,<br/> Cambridge, MA 02141',
  },
  {
    name: 'Margaret Iarossi',
    address: '66 Buick Street,<br/> Watertown, MA 02472',
  }
];
